module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "label-position": "left",
      "model": _vm.model,
      "label-width": "242px"
    }
  }, [_c('div', {
    staticClass: "edit__actions"
  }, [_c('el-button', {
    staticClass: "btn-back",
    attrs: {
      "type": "secondary"
    },
    on: {
      "click": _vm.onBack
    }
  }, [_vm._v("Back to overview")]), _vm._v(" "), _c('div', [(_vm.isOrderDetail()) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onDownloadExcel
    }
  }, [_vm._v("Download as XLS")]) : _vm._e(), _vm._v(" "), (_vm.isOrderDetail()) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onPrint
    }
  }, [_vm._v("Print")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.config.formFields), function(tab) {
    return _c('el-tab-pane', {
      key: tab.label,
      attrs: {
        "label": tab.label
      }
    }, [_vm._l((tab.body), function(item) {
      return _c(item.component, {
        key: item._uid,
        tag: "div",
        attrs: {
          "siteId": _vm.siteId,
          "permitted-sites-config": _vm.permittedSitesConfig,
          "model": _vm.model,
          "config": item,
          "root-config": _vm.rootConfig,
          "options": item.options
        }
      })
    }), _vm._v(" "), _vm._l((tab.fields), function(field) {
      return _c('el-form-item', {
        key: field.name,
        attrs: {
          "label": field.label
        }
      }, [_c(field.component, {
        tag: "div",
        attrs: {
          "placeholder": field.placeholder,
          "root-config": _vm.rootConfig,
          "options": field.options,
          "type": field.type,
          "root-model": _vm.model
        },
        model: {
          value: (_vm.model[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.model, field.name, $$v)
          },
          expression: "model[field.name]"
        }
      })], 1)
    })], 2)
  }), 1), _vm._v(" "), (!_vm.config.hideActionBar) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'admin',
          params: {
            id: 'all',
            action: 'index'
          },
        })
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa3202b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueCrudEdit.vue
// module id = 540
// module chunks = 1